import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { AlertController, ToastController, isPlatform } from '@ionic/angular';
 import { AuthService } from './services/auth/auth.service';
import {  NavigationEnd, Router } from '@angular/router';
import { DataLayerService } from './services/data-layer/data-layer.service';
import { IdbService } from './services/indexDB/idb.service';
import { SyncService } from './services/sync/sync.service';
import { RotationCheckSyncService } from './services/rotation-check/rotation-check-sync.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { UpdateQueueService } from './services/update-queue/update-queue.service';
import { releaseInfo } from './release-info.config';
import { environment } from 'src/environments/environment';
import { Browser } from '@capacitor/browser';
import { SwUpdate, UnrecoverableStateEvent, VersionReadyEvent } from '@angular/service-worker';
import { filter, map, tap } from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';
import { FileService } from './services/file/file.service';
import { FeatureFlagService } from './services/feature-flags/feature-flag.service';
import { Location } from '@angular/common';
 

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {

  user: any = null;
  PWAev: any;
  serverInfo: string = "";

  appSectionsBase = [
    { title: 'Dashboard', url: '/dashboard', icon: 'apps-outline' },
    { title: 'Jobs List', url: '/job-list', icon: 'file-tray-full-outline' },
    { title: 'New ER Job', url: '/jobs/new', icon: 'flash-outline' },
    { title: 'TimeSheet', url: '/ts-calendar', icon: 'receipt-outline' },
    // { title: 'Documents List', url: '/docs-list', icon: 'documents-outline' },  //this is now broken into subset folders
    { title: 'File Sync', url: '/file-sync', icon: 'sync-outline' },
    // { title: 'Log In', url: '/login', icon: 'log-in-outline' },  //it should get here automatically.
    { title: 'Queue list', url: 'queue-list', icon: 'cloud-upload-outline' },
    { title: 'Update App', url: '', icon: 'refresh-outline' },
    { title: 'Device Details', url: '/device', icon: 'log-in-outline' },

    { title: 'Log Out', url: '', icon: 'log-out-outline' },
    //{ title: 'Install App', url: '', icon: 'add-outline' },
  ];

  appSections = this.appSectionsBase;
  netWorkStatus: boolean = true;
  private fileScanner: Subscription;
  private folderScanner: Subscription;

  showLoader: boolean = true;
  
  event$;

  dataServerStatus: any;
  apiServerStatus: any;

  private sessionPoller: Subscription;
  private sessionCheckFailures = 0;
  private isInFailureRecoveryMode = false;
  private sessionWarningAlert: HTMLIonAlertElement = null;



  constructor(
    private auth: AuthService,
    private dl: DataLayerService,
    private router: Router,
    private idb: IdbService,
    private sync: SyncService,
    private rcSync: RotationCheckSyncService,
    private fs: FileService,
    private featureFlags: FeatureFlagService,
    private uQueue: UpdateQueueService,
    private toastController: ToastController,
    private swUpdate: SwUpdate,
    private alertController: AlertController,
    private location:Location
   ) {
    const routePath = this.location.path()
    
    this.event$ = this.location.onUrlChange((val) => {
      //console.log('url -d '+ val)
    })
    // console.log('url', routePath);
    // console.log('RELEASE INFO', releaseInfo);
    // console.log('ENVIRONMENT', environment)

    let authClient = environment.authorizationClient;

    this.getServer();
    /* Double Check Server In Case of Bad Release */
    // if (!this.dl.apiServer) {
    //   this.serverInfo = "NO SERVER FOUND";
    // } else {
    //   if (this.dl.apiServer.indexOf('pinnacle.apidas') > 0) {
    //     this.serverInfo = "PRODUCTION SERVER"
    //   } else {
    //     this.serverInfo = "DEVELOPMENT SERVER"
    //     if (this.dl.apiServer.indexOf('pwa.morrisdev.com') > 0) {
    //       this.dl.apiServer = 'https://server19.apidas.com';
    //     }
    //   }
    // }

    this.serverInfo = this.dl.apiServer.replace('https://', '');
    
    console.warn('checking updates');
    this.checkForAppUpdates();
    console.log(navigator.userAgent);

    
  }

  

  async ngOnInit() {
    this.showLoader = false;
    // setTimeout(() => {
    //   this.showLoader = false;
    // }, 3500);
    this.dl.checkOnlineNetwork().subscribe(
      res => {
        this.dataServerStatus = res;
      },
      error => {
        console.error('Error checkOnlineNetwork:', error);
        this.dataServerStatus = error; 
      }
    );
  }
  

  async ngAfterViewInit() {
    await this.idb.initializeDB();  
    await this.uQueue.init();       
  
    await this.ensureSession();

    await this.featureFlags.loadFlags();   // refresh server-driven feature flags for this session

    this.startSessionPolling(environment.sessionPolling.normalIntervalMs);
    this.checkServerSession(); // immediate first check

    await this.sync.init();
    this.rcSync.init();             // rotation-check background push/pull
    await this.loadUser();
    console.log('startFileSync')
    await this.startFileSync();
    this.dl.loadReportTemplates();
  }

  async ionViewDidEnter() {
    
    await SplashScreen.hide();
    this.dl.online$.subscribe(res => {
      this.netWorkStatus = res;
      console.log("networkStatus => ", this.netWorkStatus, this.dl.online)
    })
    
  }

  async ensureSession() {
    return new Promise<void>((resolve) => {
      const sub = this.auth.currentSessionID.subscribe(sid => {
        if (sid) {
          sub.unsubscribe();
          resolve();
        }
      });
    });
  }

  async loadUser() {
    this.user = this.auth.getUser();
    
    console.log("local user =>", this.user);
    if (this.dl.online) {
      if (this.user === null) {
        this.router.navigate(['/login']);
      } else {
        this.loadMenuData();
      }
    } else {
      this.offlineLegend();
      console.log("system offline...");
      this.loadMenuData();
    }
    
  }
  // async loadUser() {
  //   if (this.dl.online) {
  //     this.user = this.auth.getUser();
  //     console.log("local user =>", this.user);
  //     if (this.user === null) {
  //       this.router.navigate(['/login']);
  //     } else {
  //       this.loadMenuData();
    
  //       //let dashMenu = this.dl.dynamicMenuData.getValue();
  //     }
  //   } else {
  //     this.offlineLegend();
  //     console.log("system offline... getting local sessionID ")
  //     this.auth.getLocalSessionID();
  //   }
    
  // }

  loadMenuData() {
    this.dl.dynamicMenuData.subscribe((dashMenu: any) => {
      const lastTwoItemsIndex = Math.max(0, this.appSectionsBase.length - 2);
      const uniqueUrls = new Set(this.appSectionsBase.map(itemA => itemA.url));
      const updatedSections = [...this.appSectionsBase]; // Start with appSectionsBase

      dashMenu.forEach(item => {
        if (!uniqueUrls.has('/' + item.url)) {
          item.icon = 'chevron-forward-outline';
          updatedSections.splice(lastTwoItemsIndex, 0, { ...item });
          uniqueUrls.add(item.url);
        }
      });
      this.appSections = updatedSections; // Update the reference
      //console.log(this.appSections);
    });
  }

  async startFileSync() {

    if (this.netWorkStatus) { 
      await this.fs.refreshFolders();
      this.fs.processFolders();
    }

    //await this.fileScanInterval();
    //await this.folderScanInterval();


  }
  async folderScanInterval() {

    const ThirtySec = 300000;
    const source = interval(ThirtySec);
    this.folderScanner = source.subscribe(async () => {

      if (this.netWorkStatus)
        await this.fs.refreshFolders();
        this.fs.processFolders
    });
  }

  // async fileScanInterval() {
  //   const deviceSerial = this.auth.currentDeviceSerial.value;     
  //   const fiveMinutesInterval = 30000;
  //   const source = interval(fiveMinutesInterval);
  //   this.fileScanner = source.subscribe(() => {
  //     if(this.netWorkStatus)
  //       this.dl.getTrackedAssetsByDeviceSerial(deviceSerial)
  //   });
  // }

  ngOnDestroy(): void {
    if (this.fileScanner) this.fileScanner.unsubscribe();
    if (this.folderScanner) this.folderScanner.unsubscribe();
    if (this.sessionPoller) this.sessionPoller.unsubscribe();
  }

  startSessionPolling(intervalMs: number) {
    if (this.sessionPoller) this.sessionPoller.unsubscribe();
    this.sessionPoller = interval(intervalMs).subscribe(() => {
      this.checkServerSession();
    });
  }

  checkServerSession() {
    if (!this.dl.online) return;

    const sID = localStorage.getItem('currentSessionID');
    if (!sID) return;

    this.auth.getSessionStatus(sID).subscribe(
      (res: any) => {
        this.sessionCheckFailures = 0;

        if (this.isInFailureRecoveryMode) {
          this.isInFailureRecoveryMode = false;
          this.startSessionPolling(environment.sessionPolling.normalIntervalMs);
          console.log('Session polling: recovered, back to normal interval');
        }

        const expiresIn = res.ExpiresInMinutes ?? res.expiresInMinutes;

        if (expiresIn != null && expiresIn <= 1) {
          this.showSessionExpiredAlert();
          if (this.sessionPoller) this.sessionPoller.unsubscribe();
        } else if (expiresIn != null && expiresIn <= 10) {
          this.showSessionWarningAlert(sID, expiresIn);
        }
      },
      (error) => {
        this.sessionCheckFailures++;
        console.warn(`Session check failed (${this.sessionCheckFailures}/${environment.sessionPolling.maxFailures})`);

        if (this.sessionCheckFailures === 1) {
          this.isInFailureRecoveryMode = true;
          this.startSessionPolling(environment.sessionPolling.failureIntervalMs);
          console.log('Session polling: switched to failure recovery interval');
        }

        if (this.sessionCheckFailures >= environment.sessionPolling.maxFailures) {
          console.error('Session polling: max failures reached, logging out');
          if (this.sessionPoller) this.sessionPoller.unsubscribe();
          this.auth.logout();
        }
      }
    );
  }

  async showSessionWarningAlert(sID: string, expiresInMinutes: number) {
    if (this.sessionWarningAlert) return; // already showing

    this.sessionWarningAlert = await this.alertController.create({
      header: 'Session Expiring',
      message: `Your session expires in ${expiresInMinutes} minutes.`,
      backdropDismiss: false,
      buttons: [
        {
          text: 'Log Out',
          role: 'cancel',
          handler: () => {
            this.sessionWarningAlert = null;
            this.auth.logout();
          }
        },
        {
          text: 'Refresh Session',
          handler: () => {
            this.sessionWarningAlert = null;
            this.auth.renewSession(sID).subscribe(
              () => {
                console.log('Session renewed successfully');
                this.startSessionPolling(environment.sessionPolling.normalIntervalMs);
              },
              (error) => {
                console.error('Failed to renew session', error);
                this.auth.logout();
              }
            );
          }
        }
      ]
    });
    await this.sessionWarningAlert.present();
  }

  async showSessionExpiredAlert() {
    if (this.sessionWarningAlert) {
      await this.sessionWarningAlert.dismiss();
      this.sessionWarningAlert = null;
    }

    const alert = await this.alertController.create({
      header: 'Session Expired',
      message: 'Your session has expired. Please log in again.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Log Out',
          handler: () => {
            this.auth.logout();
          }
        }
      ]
    });
    await alert.present();
  }

  async navigateTo(section) {
    // if(section.title === 'Install App') {
    //   this.addPWAtoHomeScreen();
    //   return;
    // }
    if (section.title === 'Update App') {
      this.checkForAppUpdates();
      return;
    }
    if (section.title === 'Log Out') {
      this.singOut();
      return;
    } else {
      if (section.url.includes('http')) {
        await Browser.open({ url: section.url });
      } else {
        this.router.navigate([section.url]);
      }
    }
  }

  checkForAppUpdates(): void {

    console.log("running checkForUpdates... ")
    this.swUpdate.versionUpdates.pipe(
      tap(event => { console.log("event versionUpdates ", event) }),
      filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'),
    ).subscribe(async event => {
      //console.log("event checkForUpdates ", event)
      const alertDlg = await this.alertController.create({
        header: 'Update App',
        message:
          'A new version is available. Update now?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => { },
          },
          {
            text: 'Yes',
            handler: async () => {
              alertDlg.dismiss();
              this.activateUpdate();
            },
          },
        ],
      });
      await alertDlg.present();
    });

    this.swUpdate.unrecoverable.subscribe((event: UnrecoverableStateEvent) => {
      console.error('Unrecoverable state detected:', event);
    });
  }

  activateUpdate(): void {
    console.warn('activateUpdate pwa app...')
    this.swUpdate.activateUpdate().then(res => {
      if (res) {
        window.location.reload();
      }
    }).catch(error => {
      console.error('Error activating update:', error);
    });
  }

  async singOut() {
    console.log("signOut from Google ... ");
    await this.auth.logout();
  }

  getServer() {
    this.dl.getServers();
  }

  async offlineLegend() {
    const toast = await this.toastController.create({
      message: 'NETWORK IS OFFLINE!',
      duration: 3000,
      cssClass: 'noNetwork-toast',
    });

    await toast.present();
  }

}


